import { render, staticRenderFns } from "./EventValidationBox.vue?vue&type=template&id=963743ee&scoped=true&"
import script from "./EventValidationBox.vue?vue&type=script&lang=js&"
export * from "./EventValidationBox.vue?vue&type=script&lang=js&"
import style0 from "./EventValidationBox.vue?vue&type=style&index=0&id=963743ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963743ee",
  null
  
)

export default component.exports